/* EVzento theme JS — progressive enhancement over native Shopify forms */
(function () {
  'use strict';
  var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
  var lastFocus = null;

  function qs(s, el) { return (el || document).querySelector(s); }
  function qsa(s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); }

  /* ---------- drawers ---------- */
  function openDrawer(id) {
    var d = document.getElementById(id); if (!d) return;
    lastFocus = document.activeElement;
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    qsa('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var f = qs('.drawer__close', d) || qs('a,button,input', d);
    if (f) setTimeout(function () { f.focus(); }, 50);
  }
  function closeDrawer(d) {
    if (!d) return;
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
    qsa('[aria-controls="' + d.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-drawer-open')); return; }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.drawer')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    qsa('.drawer[aria-hidden="false"]').forEach(closeDrawer);
  });
  // simple focus trap
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var d = qs('.drawer[aria-hidden="false"] .drawer__panel'); if (!d) return;
    var f = qsa('a[href],button:not([disabled]),input:not([disabled]),select,textarea', d).filter(function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });

  /* ---------- search toggle ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-search-toggle]'); if (!b) return;
    var bar = document.getElementById('HeaderSearch'); if (!bar) return;
    var open = bar.hasAttribute('hidden');
    if (open) { bar.removeAttribute('hidden'); b.setAttribute('aria-expanded', 'true'); var i = qs('input', bar); if (i) i.focus(); }
    else { bar.setAttribute('hidden', ''); b.setAttribute('aria-expanded', 'false'); }
  });

  /* ---------- cart ---------- */
  function sectionIds() {
    var ids = ['cart-drawer', 'cart-count'];
    if (qs('[data-section-type="main-cart"]')) ids.push(qs('[data-section-type="main-cart"]').getAttribute('data-section-id'));
    return ids;
  }
  function renderSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id]; if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      if (id === 'cart-drawer') {
        var nb = qs('#CartDrawerInner', doc), ob = qs('#CartDrawerInner');
        if (nb && ob) ob.innerHTML = nb.innerHTML;
      } else if (id === 'cart-count') {
        var nc = qs('[data-cart-count]', doc);
        if (nc) qsa('[data-cart-count]').forEach(function (el) { el.textContent = nc.textContent; });
        var nl = qs('[data-cart-label]', doc);
        if (nl) qsa('[data-cart-label]').forEach(function (el) { el.setAttribute('aria-label', nl.getAttribute('aria-label')); });
      } else {
        var target = qs('[data-section-id="' + id + '"]');
        var src = qs('[data-section-id="' + id + '"]', doc);
        if (target && src) target.innerHTML = src.innerHTML;
      }
    });
  }
  function postJSON(url, body) {
    return fetch(root + url, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function toast(msg) {
    var t = document.createElement('div'); t.className = 'toast'; t.setAttribute('role', 'status'); t.textContent = msg;
    document.body.appendChild(t); setTimeout(function () { t.remove(); }, 3200);
  }
  function addToCart(form, btn) {
    var fd = new FormData(form);
    var items = [{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }];
    var errBox = qs('[data-form-error]', form.closest('[data-product-root]') || form);
    if (errBox) errBox.hidden = true;
    if (btn) btn.classList.add('is-loading');
    return postJSON('cart/add.js', { items: items, sections: sectionIds().join(','), sections_url: window.location.pathname })
      .then(function (res) {
        renderSections(res.sections);
        openDrawer('CartDrawer');
      })
      .catch(function (err) {
        var msg = (err && (err.description || err.message)) || 'Could not add to cart.';
        if (errBox) { errBox.textContent = msg; errBox.hidden = false; } else toast(msg);
      })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-add]'); if (!form) return;
    e.preventDefault();
    addToCart(form, e.submitter || qs('[type=submit]', form));
  });
  function changeLine(key, qty, scope) {
    if (scope) scope.classList.add('cart-updating');
    return postJSON('cart/change.js', { id: key, quantity: qty, sections: sectionIds().join(','), sections_url: window.location.pathname })
      .then(function (res) { renderSections(res.sections); })
      .catch(function (err) { toast((err && err.description) || 'Could not update the cart.'); })
      .finally(function () { if (scope) scope.classList.remove('cart-updating'); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line-change]'); if (!b) return;
    e.preventDefault();
    changeLine(b.getAttribute('data-key'), Number(b.getAttribute('data-qty')), b.closest('[data-cart-scope]'));
  });

  /* ---------- quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-step]'); if (!b) return;
    var input = qs('input', b.closest('.qty')); if (!input) return;
    var v = Math.max(1, (parseInt(input.value, 10) || 1) + Number(b.getAttribute('data-qty-step')));
    input.value = v; input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- product page ---------- */
  function initProduct(rootEl) {
    var dataEl = qs('[data-product-json]', rootEl); if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var form = qs('form[data-ajax-add]', rootEl);
    var idInput = qs('input[name=id]', form);
    var priceEl = qs('[data-price]', rootEl);
    var btn = qs('[data-add-btn]', rootEl);
    var stickyBtn = qs('[data-sticky-add]');
    var stickyPrice = qs('[data-sticky-price]');
    var qtyInput = qs('input[name=quantity]', rootEl);
    var fmt = rootEl.getAttribute('data-money-format') || '${{amount}}';

    function money(cents) {
      var n = (cents / 100).toFixed(2);
      var parts = n.split('.');
      var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
        if (k === 'amount_no_decimals') return withComma;
        if (k === 'amount_with_comma_separator') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
        if (k === 'amount_no_decimals_with_comma_separator') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return withComma + '.' + parts[1];
      });
    }
    function current() {
      var sel = qsa('[data-option-index]', rootEl).map(function (fs) {
        var c = qs('input:checked', fs); return c ? c.value : null;
      });
      return product.variants.find(function (v) { return v.options.every(function (o, i) { return sel[i] == null || o === sel[i]; }); });
    }
    function update() {
      var v = current();
      qsa('[data-option-index]', rootEl).forEach(function (fs) {
        var c = qs('input:checked', fs), l = qs('[data-option-value]', fs);
        if (c && l) l.textContent = c.value;
      });
      var q = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      if (!v) { btn.disabled = true; btn.textContent = btn.getAttribute('data-unavailable'); return; }
      idInput.value = v.id;
      var label;
      if (v.available) { btn.disabled = false; label = btn.getAttribute('data-label') + ' — ' + money(v.price * q); }
      else { btn.disabled = true; label = btn.getAttribute('data-soldout'); }
      btn.textContent = label;
      if (stickyBtn) { stickyBtn.disabled = !v.available; stickyBtn.textContent = v.available ? btn.getAttribute('data-label') : label; }
      if (priceEl) {
        priceEl.innerHTML = money(v.price) + (v.compare_at_price > v.price ? ' <s>' + money(v.compare_at_price) + '</s>' : '');
      }
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      if (v.featured_media) {
        var t = qs('[data-media-id="' + v.featured_media.id + '"]', rootEl); if (t) t.click();
      }
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    rootEl.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-index]') || e.target === qtyInput) update();
    });
    // gallery
    var main = qs('[data-gallery-main]', rootEl);
    rootEl.addEventListener('click', function (e) {
      var t = e.target.closest('[data-gallery-thumb]'); if (!t || !main) return;
      qsa('[data-gallery-thumb]', rootEl).forEach(function (x) { x.setAttribute('aria-pressed', x === t ? 'true' : 'false'); });
      var img = qs('img', main);
      img.src = t.getAttribute('data-src'); img.srcset = t.getAttribute('data-srcset') || '';
      img.alt = t.getAttribute('data-alt') || '';
      main.classList.remove('is-zoomed');
    });
    if (main) {
      main.addEventListener('click', function () { main.classList.toggle('is-zoomed'); });
      main.addEventListener('mousemove', function (e) {
        if (!main.classList.contains('is-zoomed')) return;
        var r = main.getBoundingClientRect(), img = qs('img', main);
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      });
    }
    // sticky mobile bar
    var bar = qs('.sticky-atc');
    if (bar && btn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        bar.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
      }).observe(btn);
      stickyBtn && stickyBtn.addEventListener('click', function () { addToCart(form, stickyBtn); });
    }
    update();
  }
  qsa('[data-product-root]').forEach(initProduct);

  /* ---------- collection filtering ---------- */
  function initCollection(el) {
    var cards = qsa('[data-card]', el);
    var grid = qs('[data-grid]', el);
    var state = { vehicle: 'All', type: 'All', price: 'All', sort: 'featured', limit: Number(el.getAttribute('data-page-size') || 6) };
    var pageSize = state.limit;
    var params = new URLSearchParams(window.location.search);
    ['vehicle', 'type', 'price'].forEach(function (k) { if (params.get(k)) state[k] = params.get(k).trim(); });
    if (params.get('sort')) state.sort = params.get('sort');
    var threshold = Number(el.getAttribute('data-price-split') || 3000);

    function matches(c) {
      var models = (c.getAttribute('data-models') || '').split('|').map(function (m) { return m.trim(); });
      var price = Number(c.getAttribute('data-price'));
      return (state.vehicle === 'All' || models.indexOf(state.vehicle) > -1) &&
        (state.type === 'All' || c.getAttribute('data-type') === state.type) &&
        (state.price === 'All' || (state.price === 'under' ? price < threshold : price >= threshold));
    }
    function render() {
      var list = cards.filter(matches);
      if (state.sort === 'low') list.sort(function (a, b) { return a.dataset.price - b.dataset.price; });
      else if (state.sort === 'high') list.sort(function (a, b) { return b.dataset.price - a.dataset.price; });
      else list.sort(function (a, b) { return a.dataset.index - b.dataset.index; });
      cards.forEach(function (c) { c.hidden = true; });
      list.forEach(function (c, i) { grid.appendChild(c); c.hidden = i >= state.limit; });
      var shown = Math.min(list.length, state.limit);
      qs('[data-count]', el).textContent = list.length + (list.length === 1 ? ' product' : ' products');
      qs('[data-shown]', el).textContent = 'Showing ' + shown + ' of ' + list.length;
      qs('[data-load-more]', el).hidden = list.length <= state.limit;
      qs('[data-results]', el).hidden = list.length === 0;
      qs('[data-empty]', el).hidden = list.length !== 0;
      // pills
      qsa('[data-filter]', el).forEach(function (b) {
        b.setAttribute('aria-pressed', state[b.getAttribute('data-filter')] === b.getAttribute('data-value').trim() ? 'true' : 'false');
      });
      // chips
      var chips = qs('[data-chips]', el), labels = { vehicle: 'Vehicle: ', type: 'Type: ', price: 'Price: ' };
      var active = ['vehicle', 'type', 'price'].filter(function (k) { return state[k] !== 'All'; });
      chips.innerHTML = '';
      active.forEach(function (k) {
        var pill = qs('[data-filter="' + k + '"][data-value="' + CSS.escape(state[k]) + '"]', el);
        var b = document.createElement('button'); b.type = 'button'; b.className = 'chip';
        var txt = labels[k] + (pill ? pill.textContent.trim() : state[k]);
        b.setAttribute('aria-label', 'Remove filter ' + txt); b.textContent = txt;
        var x = document.createElement('span'); x.setAttribute('aria-hidden', 'true'); x.textContent = '×'; b.appendChild(x);
        b.addEventListener('click', function () { state[k] = 'All'; state.limit = pageSize; render(); });
        chips.appendChild(b);
      });
      if (active.length) {
        var c = document.createElement('button'); c.type = 'button'; c.className = 'link-btn'; c.style.color = 'var(--c-action)';
        c.textContent = 'Clear all'; c.addEventListener('click', clearAll); chips.appendChild(c);
      }
      chips.hidden = !active.length;
      var ft = qs('[data-filters-toggle]', el);
      if (ft) ft.textContent = 'Filters' + (active.length ? ' (' + active.length + ')' : '');
      var u = new URL(window.location.href);
      ['vehicle', 'type', 'price'].forEach(function (k) { if (state[k] === 'All') u.searchParams.delete(k); else u.searchParams.set(k, state[k]); });
      if (state.sort === 'featured') u.searchParams.delete('sort'); else u.searchParams.set('sort', state.sort);
      window.history.replaceState({}, '', u.toString());
    }
    function clearAll() { state.vehicle = state.type = state.price = 'All'; state.limit = pageSize; render(); }
    el.addEventListener('click', function (e) {
      var b = e.target.closest('[data-filter]');
      if (b) { state[b.getAttribute('data-filter')] = b.getAttribute('data-value').trim(); state.limit = pageSize; render(); return; }
      if (e.target.closest('[data-load-more]')) { state.limit += pageSize; render(); return; }
      if (e.target.closest('[data-clear]')) { clearAll(); return; }
      var t = e.target.closest('[data-filters-toggle]');
      if (t) { var f = qs('.filters', el), open = f.getAttribute('data-open') !== 'true'; f.setAttribute('data-open', open); t.setAttribute('aria-expanded', open); }
    });
    var sortSel = qs('[data-sort]', el);
    if (sortSel) { sortSel.value = state.sort; sortSel.addEventListener('change', function () { state.sort = sortSel.value; render(); }); }
    render();
  }
  qsa('[data-collection-root]').forEach(initCollection);

  /* ---------- newsletter consent ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-newsletter]'); if (!form) return;
    var email = qs('input[type=email]', form), consent = qs('input[type=checkbox][data-consent]', form), msg = qs('[data-newsletter-msg]', form);
    var bad = '';
    if (!/^\S+@\S+\.\S+$/.test(email.value)) bad = form.getAttribute('data-err-email');
    else if (consent && !consent.checked) bad = form.getAttribute('data-err-consent');
    if (bad) {
      e.preventDefault(); email.setAttribute('aria-invalid', String(!/^\S+@\S+\.\S+$/.test(email.value)));
      if (msg) { msg.textContent = bad; msg.className = 'signup__msg signup__msg--err'; }
    }
  });
})();
